namespace TabAurous.OMS {
    export namespace CommonAttributesService {
        export const baseUrl = 'OMS/CommonAttributes';

        export declare function Create(request: Serenity.SaveRequest<CommonAttributesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CommonAttributesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CommonAttributesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CommonAttributesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductATB(request: CommonAttributeRequest, onSuccess?: (response: Common.CommonAttributeResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckAttributeUsage(request: AttributeRequest, onSuccess?: (response: Serenity.RetrieveResponse<CommonAttributesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/CommonAttributes/Create",
            Update = "OMS/CommonAttributes/Update",
            Delete = "OMS/CommonAttributes/Delete",
            Retrieve = "OMS/CommonAttributes/Retrieve",
            List = "OMS/CommonAttributes/List",
            GetProductATB = "OMS/CommonAttributes/GetProductATB",
            CheckAttributeUsage = "OMS/CommonAttributes/CheckAttributeUsage"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetProductATB', 
            'CheckAttributeUsage'
        ].forEach(x => {
            (<any>CommonAttributesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
